(() => {
  const selectors = {
    section: '[data-ers-instagram-feed]',
    track: '[data-instagram-track]',
    previous: '[data-instagram-previous]',
    next: '[data-instagram-next]',
    post: '[data-instagram-post]',
  };

  const updateVisiblePositions = (track) => {
    if (!window.matchMedia('(min-width: 990px)').matches) {
      track.querySelectorAll(selectors.post).forEach((post) => {
        post.classList.remove('is-visible-small', 'is-visible-large');
      });
      return;
    }

    const trackRect = track.getBoundingClientRect();
    const posts = Array.from(track.querySelectorAll(selectors.post));
    const visiblePosts = posts
      .map((post) => {
        const rect = post.getBoundingClientRect();

        return {
          post,
          left: rect.left,
          isVisible: rect.right > trackRect.left && rect.left < trackRect.right,
        };
      })
      .filter((entry) => entry.isVisible)
      .sort((first, second) => first.left - second.left);

    posts.forEach((post) => {
      post.classList.remove('is-visible-small', 'is-visible-large');
    });

    visiblePosts.forEach(({ post }, index) => {
      post.classList.add(index === 1 || index === 3 ? 'is-visible-small' : 'is-visible-large');
    });
  };

  const getScrollAmount = (track) => {
    const firstPost = track.querySelector(selectors.post);

    if (!firstPost) {
      return track.clientWidth;
    }

    const trackStyle = window.getComputedStyle(track);
    const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || 0);

    return firstPost.getBoundingClientRect().width + gap;
  };

  const initInstagramFeed = (section) => {
    if (section.dataset.instagramFeedInitialized === 'true') {
      return;
    }

    const track = section.querySelector(selectors.track);
    const previousButton = section.querySelector(selectors.previous);
    const nextButton = section.querySelector(selectors.next);

    if (!track || !previousButton || !nextButton) {
      return;
    }

    let animationFrame;
    const scheduleVisiblePositionUpdate = () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(() => updateVisiblePositions(track));
    };

    scheduleVisiblePositionUpdate();

    track.addEventListener('scroll', scheduleVisiblePositionUpdate, { passive: true });
    window.addEventListener('resize', scheduleVisiblePositionUpdate);

    previousButton.addEventListener('click', () => {
      track.scrollBy({
        left: -getScrollAmount(track),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    });

    nextButton.addEventListener('click', () => {
      track.scrollBy({
        left: getScrollAmount(track),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    });

    section.dataset.instagramFeedInitialized = 'true';
  };

  const initAllInstagramFeeds = (root = document) => {
    root.querySelectorAll(selectors.section).forEach(initInstagramFeed);
  };

  initAllInstagramFeeds();

  document.addEventListener('shopify:section:load', (event) => {
    initAllInstagramFeeds(event.target);
  });
})();
